var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84 42.001C84 65.1988 65.1975 84.0007 42.0007 84C18.8025 84.0007 5.26029e-08 65.1988 5.26029e-08 42.001C-0.00114838 18.8032 18.8025 0 42.0007 0C65.1975 0 84 18.8039 84 42.001Z",
    fill: "#D72222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M83.9528 43.8658C83.9332 43.8433 83.9137 43.8208 83.8924 43.7998C83.8558 43.7636 62.1192 22.0263 62.0732 21.9808C62.0368 21.9447 61.9961 21.9147 61.9595 21.8789C61.9134 21.8327 61.8745 21.7815 61.8281 21.7355C56.5338 16.4964 49.455 13.6701 41.9797 13.8166C34.4277 13.9464 27.3208 16.9973 21.9691 22.4071C16.5816 27.8528 13.6864 34.9854 13.8162 42.4908C13.9473 50.0414 16.9148 57.0639 22.1726 62.2649C22.2096 62.3015 22.2508 62.3322 22.2879 62.3684C22.3332 62.4139 22.3719 62.4647 22.4177 62.51C22.4547 62.5466 43.8247 83.9061 43.8618 83.9425C43.8651 83.9458 43.8678 83.9495 43.8713 83.9528C65.5805 83.0013 83.0035 65.5765 83.9528 43.8658Z",
    fill: "#B10808"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M41.9797 13.817C34.4275 13.9467 27.3208 16.9976 21.9691 22.4074C16.5816 27.8532 13.6864 34.9858 13.8162 42.4911C13.9473 50.0421 16.9147 57.0645 22.1726 62.2654C27.35 67.3868 34.2046 70.1892 41.5232 70.1892C41.6889 70.1892 41.856 70.188 42.0223 70.1849C49.5744 70.0538 56.6806 67.0026 62.0319 61.5928C67.42 56.1474 70.3144 49.0156 70.1843 41.5109C70.0532 33.9594 67.0863 26.937 61.8286 21.7361C56.534 16.4966 49.4552 13.6703 41.9797 13.817ZM67.7327 41.5532C67.8525 48.3913 65.2085 54.8962 60.2897 59.869C55.3905 64.8202 48.8878 67.6137 41.9793 67.7335C35.1489 67.8693 28.7177 65.2914 23.8967 60.5224C19.0961 55.7745 16.3871 49.3554 16.2675 42.4483C16.1485 35.6091 18.7922 29.1035 23.7118 24.1307C28.611 19.1795 35.1136 16.3867 42.0222 16.2682C42.1752 16.2653 42.3286 16.264 42.4812 16.264C49.1489 16.264 55.3914 18.8156 60.1048 23.4779C64.9041 28.2264 67.6131 34.6457 67.7329 41.5527C67.7327 41.5532 67.7327 41.5532 67.7327 41.5532Z",
    fill: "#F4F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42 46.9031C42.6769 46.9031 43.2255 46.3543 43.2255 45.6776V26.0683C43.2255 25.3914 42.6767 24.8428 42 24.8428C41.323 24.8428 40.7744 25.3916 40.7744 26.0683V45.6774C40.7744 46.3543 41.323 46.9031 42 46.9031Z",
    fill: "#F4F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.0011 51.8052H41.9568C40.6048 51.8052 39.5253 52.9461 39.5492 54.2981C39.572 55.6385 40.6645 56.7075 41.9987 56.7075H42.043C43.395 56.7075 44.4745 55.5666 44.4506 54.2146C44.4266 52.8742 43.3355 51.8052 42.0011 51.8052Z",
    fill: "#F4F6F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.4358f1c719d1e3c0dd5188de83c76bf3.svg";
export { ForwardRef as ReactComponent };